import classNames from 'classnames'
import * as React from 'react'

import { TooltipInput } from '../../../../components/tooltip-input'
import { usePortfolioBulkEditRowContext } from '../PortfolioBulkEditRowContext'
import { EditColumnProps } from './types'

const TICKER_MAX_LENGTH = 10

export function TickerEditColumn<
  StateType extends {
    ticker: string
  },
  ErrorsType extends {
    ticker?: boolean
  },
>(props: EditColumnProps<StateType, ErrorsType>) {
  const { isActive, setIsInteracting } = usePortfolioBulkEditRowContext()
  const handleChange = React.useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      const ticker = ev.currentTarget.value
      if (ticker.trim().length >= 0 && props.errors?.ticker) props.setErrors((errors) => ({ ...errors, ticker: false }))
      props.setState((entry) => ({ ...entry, ticker }))
    },
    [props]
  )

  let tooltipContent = undefined
  if (props.errors?.ticker && isActive) {
    tooltipContent = props.entry.ticker.length === 0 ? 'Missing ticker' : 'Invalid ticker'
  }

  return (
    <TooltipInput
      isMobileStyleEnabled={false}
      name="ticker"
      label={props.label}
      isHorizontalLabel={props.isHorizontalLabel}
      labelClassName={props.labelClassName}
      form={props.form}
      error={props.errors?.ticker}
      className={classNames(props.className, { 'is-error': props.errors?.ticker })}
      value={props.entry.ticker}
      onChange={handleChange}
      size={props.size}
      tooltipColor="red"
      tooltipSettings={{ unstable_offset: [10, 10] }}
      tooltipContent={tooltipContent}
      maxLength={TICKER_MAX_LENGTH}
      isInteractive={isActive}
      onFocus={() => setIsInteracting(true)}
      onBlur={() => setIsInteracting(false)}
    />
  )
}
